import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { iPieChartData } from '../chart.interfaces';
import * as d3 from 'd3';

import randomColor from 'randomcolor';

interface iColorLegend{
  key: string;
  color: string;
}
interface iVolumeStats{
  name: string;
  total: number;
  live: number;
  transported: number;
  highlight?:boolean;
}
@Component({
  selector: 'app-volume-pie-chart',
  templateUrl: './volume-pie-chart.component.html',
  styleUrls: ['./volume-pie-chart.component.scss'],
})
export class VolumePieChartComponent implements AfterViewInit {
  @Input() data:any;
  @Input()
  get centered():boolean{
    return this._centered;
  }
  set centered(value:boolean){
    this._centered = !!value;
  }
  @ViewChild('figure') figure: ElementRef;
  @ViewChild('tooltip') tooltip: ElementRef;

  public _centered:boolean = false;
  private svg;
  private margin:number = 0;
  private width:number = 180;
  private height:number = 180;
  private radius = Math.min(this.width, this.height) / 2 - this.margin;
  private combined:iPieChartData[] = [];
  private split:iPieChartData[] = [];

  public colors;
  public colorLegend:iColorLegend[] = [];
  public stats:iVolumeStats[] = [];
  public statTotals:any[] = [];
  private svgCombined;
  private svgSplit;
  private svgRadial;

  private init:boolean = false;
  createColorLegend(){
    this.colorLegend = this.combined.map( (d:any)=>{
      return {key:d.name,color:this.colors[d.name]};
    });
  }
  createStats(){
    const statTotals:any = {
      total:0,
      live:0,
      transported:0
    }
    this.stats = Object.keys(this.data).map( (k)=>{
      let {total,live,transported} = this.data[k];
      total = Number((total||0).toFixed(2));
      live = Number((live||0).toFixed(2));
      transported = Number((transported||0).toFixed(2));
      statTotals.total += total;
      statTotals.live += live;
            statTotals.transported += transported;
      return  Object.assign( {name: k }, {live,transported,total}) ;
    });
    this.statTotals = ['live','transported','total'].map( (k:string)=>{
      return Number(statTotals[k].toFixed(2));
    });

  }
  constructor() {

  }
  private createColors(): void {
      this.colors = this.combined.reduce( (clrs:any,d:any)=>{
        clrs[d.name]=randomColor({seed:`${d.name}:${d.name}`});
        return clrs;
      },{});
  }

  private prepareData(){
    Object.keys(this.data).forEach( (k)=>{
      let {total,live,transported} = this.data[k];
      total = Number((total||0).toFixed(2));
      live = Number((live||0).toFixed(2));
      transported = Number((transported||0).toFixed(2));
      this.combined.push({name:k,value:total});
      this.split.push({name:`${k}-I`,value:live})
      this.split.push({name:`${k}-O`,value:transported})
    });
  }

  private createSvg():void{
    this.svg = d3.select(this.figure.nativeElement)
                .append('svg')
                .attr('width', this.width )
                .attr('height', this.height);
    this.svgCombined = this.svg.append('g')
                                .attr("transform",   "translate(" + this.width / 2 + "," + this.height / 2 + ")");
    this.svgSplit = this.svg.append('g')
                                .attr("transform",   "translate(" + this.width / 2 + "," + this.height / 2 + ")");

  }

  private drawChart(): void {
    const rCombined:number=this.radius;
    const rSplit:number=0.66*this.radius;

    const pie = d3.pie<any>().value( (d:iPieChartData)=> Number(d.value) ).sort(null);
    const arcCombined = d3.arc().innerRadius(rCombined*0.77).outerRadius(rCombined*0.88);

    const arcSplit = d3.arc().innerRadius(rCombined*0.88).outerRadius(rCombined);

    const pathCombined = this.svgCombined.selectAll('path')
                                         .data( pie( this.combined ) )
                                         .enter()
                                         .append('path')
                                         .attr('d',arcCombined)
                                         .attr('fill', (d:any,i:number)=>{
                                           return this.colors[d.data.name];
                                         }).attr('stroke','#ffffff').style('stroke-width','3px');
   const pathSplit = this.svgSplit.selectAll('path')
                                        .data( pie( this.split ) )
                                        .enter()
                                        .append('path')
                                        .attr('d',arcSplit)
                                        .attr('fill', (d:any,i:number)=>{
                                          let [code,type] = d.data.name.split('-');
                                          if(type == 'I') return '#999999';
                                          return '#333333';
                                        }).attr('stroke','#ffffff').style('stroke-width', '3px');


  pathCombined.on('mousemove', (e,d)=>{

    if(this.stats){

      this.stats.forEach( (s:any,i:number)=>{
        if(d.data.name == s.name){
          this.stats[i].highlight = true;
        }else{
          this.stats[i].highlight = false;
        }
      })
    }

  })
  pathCombined.on("mouseout", (e,d)=>{

        if(this.stats){
          this.stats.forEach( (s:any,i:number)=>{
              this.stats[i].highlight = false;

          })
        }
        pathSplit.on('mousemove', (e,d)=>{

          if(this.stats){
            let [name] =  d.data.name.split('-');
            this.stats.forEach( (s:any,i:number)=>{
              if(name == s.name){
                this.stats[i].highlight = true;
              }else{
                this.stats[i].highlight = false;
              }
            })
          }

        })
        pathSplit.on("mouseout", (e,d)=>{

              if(this.stats){
                this.stats.forEach( (s:any,i:number)=>{
                    this.stats[i].highlight = false;

                })
              }
            })
});
  // const labelLocation = d3.arc().innerRadius(rCombined*0.33).outerRadius(rCombined*0.55);
  // this.svgCombined.selectAll('pieces')
  //                 .data(pie(this.combined))
  //                 .enter()
  //                 .append('text')
  //                 .text( d=> d.data.value )
  //                 .attr("transform", d => "translate(" + labelLocation.centroid(d) + ")")
  //                 .style("text-anchor", "middle")
  //                 .style("font-size", 12);

  }
  ngAfterViewInit() {
    setTimeout( ()=>{
      this.prepareData();
      this.createColors();
      this.createColorLegend();
      this.createStats();
      this.createSvg();
      this.drawChart();
    })


  }

}
